import React from 'react';

interface LoaderComponentProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

const LoaderComponent: React.FC<LoaderComponentProps> = ({ 
  size = 'md', 
  text = 'Loading...', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const containerClasses = {
    sm: 'py-4',
    md: 'py-8',
    lg: 'py-12'
  };

  return (
    <div className={`flex items-center justify-center ${containerClasses[size]} ${className}`}>
      <div className={`animate-spin rounded-full border-b-2 border-purple-600 ${sizeClasses[size]}`}></div>
    </div>
  );
};

export default LoaderComponent;